var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 18,
    viewBox: "0 0 67 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3989 7.655H28.8169V15H31.0399V7.655H33.4579V5.874H26.3989V7.655ZM43.4506 10.411C43.4506 7.668 41.3836 5.744 38.7836 5.744C36.1966 5.744 34.0906 7.668 34.0906 10.411C34.0906 13.154 36.1966 15.091 38.7836 15.091C41.3706 15.091 43.4506 13.154 43.4506 10.411ZM36.3656 10.411C36.3656 8.786 37.3016 7.759 38.7836 7.759C40.2396 7.759 41.1886 8.786 41.1886 10.411C41.1886 12.01 40.2396 13.063 38.7836 13.063C37.3016 13.063 36.3656 12.01 36.3656 10.411ZM50.6492 5.874H47.2302V15H50.6492C53.5612 15 55.4332 13.141 55.4332 10.437C55.4332 7.72 53.5612 5.874 50.6492 5.874ZM49.4532 13.076V7.772H50.5062C52.1832 7.772 53.1712 8.76 53.1712 10.437C53.1712 12.114 52.1832 13.076 50.5062 13.076H49.4532ZM65.5525 10.411C65.5525 7.668 63.4855 5.744 60.8855 5.744C58.2985 5.744 56.1925 7.668 56.1925 10.411C56.1925 13.154 58.2985 15.091 60.8855 15.091C63.4725 15.091 65.5525 13.154 65.5525 10.411ZM58.4675 10.411C58.4675 8.786 59.4035 7.759 60.8855 7.759C62.3415 7.759 63.2905 8.786 63.2905 10.411C63.2905 12.01 62.3415 13.063 60.8855 13.063C59.4035 13.063 58.4675 12.01 58.4675 10.411Z",
    fill: "#3F76E2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4.55566,
    width: 17.7778,
    height: 12.4444,
    rx: 2,
    stroke: "#3F76E2",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4442 17V2.77778C13.4442 1.79594 12.6483 1 11.6664 1H8.11089C7.12905 1 6.33311 1.79594 6.33311 2.77778V17",
    stroke: "#3F76E2",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.b2c451574fbbd0ba5204bfbbf5d96454.svg";
export { ForwardRef as ReactComponent };